
const url = new URL(window.location.href)
export const NSFW_ENABLED = url.searchParams.has('nsfw')
